import { render } from "./add-dialog.vue?vue&type=template&id=03f9d80e&scoped=true&ts=true"
import script from "./add-dialog.vue?vue&type=script&lang=ts"
export * from "./add-dialog.vue?vue&type=script&lang=ts"

import "./add-dialog.vue?vue&type=style&index=0&id=03f9d80e&lang=scss&scoped=true"

import exportComponent from "/Users/star/Desktop/clz-frontend/taxi-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03f9d80e"]])

export default __exports__